import { createBrowserRouter } from "react-router-dom";
import CreateResume from "../components/CreateResume/CreateResume";
import Resume from "../components/Resume/Resume";
import Main from "../layouts/Main";
import Blog from "../Pages/Blog/Blog";
import Contact from "../Pages/Contact/Contact";
import ErrorPage from "../Pages/ErrorPage/ErrorPage";
import Home from "../Pages/Home/Home/Home";
import Login from "../Pages/Login/Login";
import Profile from "../Pages/Profile/Profile";
import Register from "../Pages/Register/Register";
import ResetPass from "../Pages/ResetPass/ResetPass";
import PriveteRoute from "./PrivateRoute/PriveteRoute";

export const routes = createBrowserRouter([
    {
        path: '/',
        element: <Main></Main>,
        children: [
            {
                path: '/',
                element: <Home></Home>,
            },


            {
                path: '/blog',
                element: <Blog></Blog>,
                loader: () => fetch('https://assignment-10-server-beta.vercel.app/blog')
            },
            {
                path: '/contact',
                element: <Contact></Contact>
            },
            {
                path: '/login',
                element: <Login></Login>
            },
            {
                path: '/register',
                element: <Register></Register>
            },
            {
                path: '*',
                element: <ErrorPage></ErrorPage>
            },




            {
                path: '/profile',
                element: <Profile></Profile>
            },

            {
                path: '/reset-password',
                element: <ResetPass></ResetPass>
            },
            {
                path: '/my-resume',
                element: <PriveteRoute><Resume></Resume></PriveteRoute>
            },
            {
                path: '/create-resume',
                element: <PriveteRoute><CreateResume></CreateResume></PriveteRoute>
            }
        ]
    }
])